import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchReferralDashboard } from '../../api/products';
import { formatRublesForUser } from '../../utils/formatRubles';
import './ReferralDashboardPage.css';

function formatReferralRub(n) {
  const s = formatRublesForUser(n);
  return s === '' ? '—' : s;
}

export default function ReferralDashboardPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    setErr('');
    setLoading(true);
    try {
      const d = await fetchReferralDashboard(12);
      setData(d);
    } catch (e) {
      setErr(e?.message || 'Не удалось загрузить');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    const backButton = tg?.BackButton;
    if (!backButton) {
      return undefined;
    }
    const handleBack = () => navigate(-1);
    backButton.onClick(handleBack);
    backButton.show();
    return () => {
      backButton.offClick(handleBack);
      backButton.hide();
    };
  }, [navigate]);

  return (
    <div className="referral-page page-container">
      <div className="referral-page__header">
        <h1 className="referral-page__title">Промокоды и начисления</h1>
      </div>

      {loading && <p className="referral-page__muted">Загрузка…</p>}
      {err && <p className="referral-page__error">{err}</p>}

      {!loading && data && !data.eligible && (
        <p className="referral-page__muted">У вас нет персональных промокодов с начислением.</p>
      )}

      {!loading && data && data.eligible && (
        <>
          <section className="referral-page__card">
            <div className="referral-page__stat">
              <span className="referral-page__stat-label">Текущий месяц ({data.current_month})</span>
              <div className="referral-page__stat-row">
                <span>Завершённых заказов по коду</span>
                <strong>{data.completed_orders_this_month}</strong>
              </div>
              <div className="referral-page__stat-row">
                <span>К выплате (ориентир)</span>
                <strong className="referral-page__sum">{formatReferralRub(data.commission_due_this_month_rub)}</strong>
              </div>
            </div>
            {data.promocodes?.length > 0 && (
              <div className="referral-page__codes">
                <div className="referral-page__codes-title">Ваши коды</div>
                <ul className="referral-page__codes-list">
                  {data.promocodes.map((p) => (
                    <li key={p.id}>
                      <code>{p.code}</code>
                      <span className="referral-page__muted"> · {p.commission_percent}% от сервисного сбора</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </section>

          {data.note && <p className="referral-page__note">{data.note}</p>}

          <section className="referral-page__history">
            <h2 className="referral-page__history-title">По месяцам</h2>
            <div className="referral-page__table-wrap">
              <table className="referral-page__table">
                <thead>
                  <tr>
                    <th>Месяц</th>
                    <th>Заказов</th>
                    <th>К выплате</th>
                  </tr>
                </thead>
                <tbody>
                  {(data.history || []).map((row) => (
                    <tr key={row.year_month}>
                      <td>{row.year_month}</td>
                      <td>{row.completed_orders}</td>
                      <td>{formatReferralRub(row.commission_rub)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </>
      )}
    </div>
  );
}
